export default __webpack_public_path__ + "static/media/mask9.3d8911fd.jpeg";